import React from "react";
import EmailThreadList from "../../../components/email/EmailThreadList";
import {
  useAllThreadsQuery,
  useUpdateStarredMutation,
  useUpdateNonActionableMutation,
  useUpdateActionableMutation,
} from "../../../Services/email/EmailInbox";
import EmailFilterModal from "../../../components/email/InboxlFilterModal";

const Inbox = () => {
  return (
    <EmailThreadList
      useThreadsQuery={useAllThreadsQuery}
      useUpdateStarredMutation={useUpdateStarredMutation}
      useUpdateNonActionableMutation={useUpdateNonActionableMutation}
      useUpdateActionableMutation={useUpdateActionableMutation}
      FilterModalComponent={EmailFilterModal}
      filterSessionKey="selectedFilter"
      sessionKeyPrefix="inboxInitial_"
      title="Inbox"
      filterKey="selectedFilter1"
    />
  );
};
export default Inbox;